<template>
<div>
  <b-dropdown
    :toggle-class="dropdownToggleClass"
    :variant="variant"
    class="apply-inline-button"
    v-if="loaded"
  >
    <template
      slot="button-content"
    >
      <ItpText
        :text="'No register have been defined yet.'|pgettext('RegisterSelector')"
        v-if="noRegisterDefined"
      >
      </ItpText>
      <ItpText
        :text="'Select register'|pgettext('RegisterSelector')"
        v-if="!noRegisterDefined && !selectedRegister"
      >
      </ItpText>
      <DIV
        v-if="selectedRegister && selectedRegister.register"
      >
        <ItpText
          :muted="selectedRegister.register.inactive"
          :strikethrough="selectedRegister.register.inactive"
        >
          <span
            class="pr-1"
          >
            {{ selectedRegister.register.name }}
          </span>
        </ItpText>
      </DIV>
    </template>
    <b-dropdown-item-button
      :key="register.id"
      v-for="register in registers"
      @click.prevent="evh_5962862420439144_clickPrevent($event, {register})"
    >
      <ItpText
        :muted="register.inactive"
        :strikethrough="register.inactive"
      >
        <strong>
          {{ register.name }}
        </strong>
      </ItpText>
    </b-dropdown-item-button>
    <b-dropdown-divider
      v-if="!noRegisterDefined"
    >
    </b-dropdown-divider>
    <ItpNavItem
      href="#"
      dropdown-item
      icon="fa-cog"
      :text="'Configure registers...'|pgettext('RegisterSelector')"
      @click.prevent="evh_1048678296148443_clickPrevent($event, {})"
    >
    </ItpNavItem>
  </b-dropdown>
  <b-dropdown
    :toggle-class="dropdownToggleClass"
    variant="light"
    class="apply-inline-button mx-2"
    v-if="loaded && !noRegisterDefined && selectedRegister && selectedRegister.register"
  >
    <template
      slot="button-content"
    >
      <ItpText
        :muted="selectedRegister.version && selectedRegister.version.inactive"
        :strikethrough="selectedRegister.version && selectedRegister.version.inactive"
      >
        <span
          class="pr-1"
        >
          {{ selectedRegister.version && selectedRegister.version.name }}
        </span>
      </ItpText>
    </template>
    <b-dropdown-item-button
      :key="version.id"
      v-for="version in selectedRegister.register.versions.data"
      @click.prevent="evh_5974459770896956_clickPrevent($event, {version})"
    >
      <ItpText
        :muted="version.inactive"
        :strikethrough="version.inactive"
      >
        <strong>
          {{ version.name }}
        </strong>
      </ItpText>
    </b-dropdown-item-button>
  </b-dropdown>
</div>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcRegisterSelector extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  applySelection(...args: any[]) {
    const { selectedRegisterId, selectedVersionId } = this.value ?? {};

    if (args[0]) {
      let [{ register, version }] = args;

      if (!version) {
        version = _
          .chain(register.versions.data)
          .orderBy(['financial_year'], ['desc'])
          .first()
          .value();
      }

      if (
        selectedRegisterId != register.id ||
        selectedVersionId != version.id
      ) {
        this.$emit('input', {
          selectedRegisterId: register.id,
          selectedVersionId: version.id
        })
      }
      return args[0];
    }

    this.$emit('input', {
      selectedRegisterId: null,
      selectedVersionId: null
    })

    return null;
  }

  selectByCache(...args: any[]) {
    const [registers, value] = args;
    const { selectedRegisterId, selectedVersionId } = value;

    if (selectedRegisterId && selectedVersionId) {
      let selection = null

      for (let register of registers) {
        if (register.id == selectedRegisterId && register.versions) {
          for (let version of register.versions.data) {
            if (version.id == selectedVersionId) {
              return { register, version };
            }
          }
        }
      }
    }
  }

  selectFirst(...args: any[]) {
    const [registers] = args

    if (registers && registers.length) {
      for (let register of registers) {
        if (register.versions) {
          for (let version of _.orderBy(register.versions.data, ['financial_year'], ['desc'])) {
            return { register, version };
          }
        }
      }
    }
  }

  @Prop({
    type: Object,
    default: { "selectedRegisterId": null, "selectedVersionId": null },
  })
  value!: object;

  @Watch('value')
  onValue(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("value")
  }

  @Prop({
    type: String,
  })
  cacheKey!: string;

  @Watch('cacheKey')
  onCache_key(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("cacheKey")
  }

  @Prop({
    type: String,
  })
  companyId!: string;

  @Watch('companyId')
  onCompany_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("companyId")
  }

  @Prop({
    type: String,
    default: "light",
  })
  variant!: string;

  @Watch('variant')
  onVariant(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("variant")
  }

  @Prop({
    type: String,
  })
  toggleClass!: string;

  @Watch('toggleClass')
  onToggle_class(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("toggleClass")
  }

  registers!: any;

  async $$load_registers() {
    return this.$fn.fetch('list_register', { parameters: { company_id: this.companyId } }).then(d => _.sortBy(d, 'name'))
  }

  selectedRegister!: any;

  async $$load_selectedRegister() {
    return this.applySelection(
      this.selectByCache(this.$data.registers, this.value) || this.selectFirst(this.$data.registers)
    )
  }

  ux!: any;
  dataMembers = ['registers', 'selectedRegister', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        registers: null,
        selectedRegister: null,
        ux: null,
      },
    }
  }

  get noRegisterDefined() {
    if (this.loaded) {

      return !this.registers.length
    }
    return null;
  }

  get dropdownToggleClass() {
    if (this.loaded) {

      return 'border ' + (this.toggleClass || '')
    }
    return null;
  }

  async act_5962862420439144_setData_8102_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_5962862420439144_setData_8102, alias=undefined
    return {
      path: "selectedRegister",
      value: this.applySelection({ register: $event.scope.register }),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_5962862420439144_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_clickPrevent.executeFromDOM(this, event, scope);
  }

  async act_1048678296148443_showModal_8104_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_1048678296148443_showModal_8104, alias=undefined
    return {
      name: "Registers",
    }
  }

  async evh_1048678296148443_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1048678296148443_clickPrevent.executeFromDOM(this, event, scope);
  }

  async act_5974459770896956_setData_8108_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_5974459770896956_setData_8108, alias=undefined
    return {
      path: "selectedRegister",
      value: this.applySelection({ register: this.selectedRegister.register, version: $event.scope.version }),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_5974459770896956_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5974459770896956_clickPrevent.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_5962862420439144_setData_8102: actions.SetDataAction;
    evh_5962862420439144_clickPrevent_8101: actions.EventHandlerImpl;
    evh_5962862420439144_clickPrevent: actions.EventHandlerGroup;
    act_1048678296148443_reloadComponentData_8106: actions.ReloadComponentDataAction;
    evh_1048678296148443_close_8105: actions.EventHandlerImpl;
    act_1048678296148443_showModal_8104: actions.ShowModalAction;
    evh_1048678296148443_clickPrevent_8103: actions.EventHandlerImpl;
    evh_1048678296148443_clickPrevent: actions.EventHandlerGroup;
    act_5974459770896956_setData_8108: actions.SetDataAction;
    evh_5974459770896956_clickPrevent_8107: actions.EventHandlerImpl;
    evh_5974459770896956_clickPrevent: actions.EventHandlerGroup;
  }

  getActions() {
    const act_5962862420439144_setData_8102 = new actions.SetDataAction(
      {
        actionArgs: this.act_5962862420439144_setData_8102_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_clickPrevent_8101 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_setData_8102,
        event: "click.prevent",
        displayName: "setData",
      }
    );
    const evh_5962862420439144_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_clickPrevent_8101],
      }
    );
    const act_1048678296148443_reloadComponentData_8106 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_1048678296148443_close_8105 = new actions.EventHandlerImpl(
      {
        action: act_1048678296148443_reloadComponentData_8106,
        event: "close",
        displayName: "reloadComponentData",
      }
    );
    const act_1048678296148443_showModal_8104 = new actions.ShowModalAction(
      {
        actionArgs: this.act_1048678296148443_showModal_8104_getActionArgs,
        events: [evh_1048678296148443_close_8105],
      }
    );
    const evh_1048678296148443_clickPrevent_8103 = new actions.EventHandlerImpl(
      {
        action: act_1048678296148443_showModal_8104,
        event: "click.prevent",
        displayName: "showModal",
      }
    );
    const evh_1048678296148443_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_1048678296148443_clickPrevent_8103],
      }
    );
    const act_5974459770896956_setData_8108 = new actions.SetDataAction(
      {
        actionArgs: this.act_5974459770896956_setData_8108_getActionArgs,
        events: [],
      }
    );
    const evh_5974459770896956_clickPrevent_8107 = new actions.EventHandlerImpl(
      {
        action: act_5974459770896956_setData_8108,
        event: "click.prevent",
        displayName: "setData",
      }
    );
    const evh_5974459770896956_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_5974459770896956_clickPrevent_8107],
      }
    );
    return {
      act_5962862420439144_setData_8102,
      evh_5962862420439144_clickPrevent_8101,
      evh_5962862420439144_clickPrevent,
      act_1048678296148443_reloadComponentData_8106,
      evh_1048678296148443_close_8105,
      act_1048678296148443_showModal_8104,
      evh_1048678296148443_clickPrevent_8103,
      evh_1048678296148443_clickPrevent,
      act_5974459770896956_setData_8108,
      evh_5974459770896956_clickPrevent_8107,
      evh_5974459770896956_clickPrevent,
    }
  }
}

Vue.component("UcRegisterSelector", UcRegisterSelector);

</script>